var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReplay = function SvgReplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.5V0.5L3 5.5L8 10.5V6.5C11.31 6.5 14 9.19 14 12.5C14 15.81 11.31 18.5 8 18.5C4.69 18.5 2 15.81 2 12.5H0C0 16.92 3.58 20.5 8 20.5C12.42 20.5 16 16.92 16 12.5C16 8.08 12.42 4.5 8 4.5Z"
  }))));
};
export default SvgReplay;